$(document).on("click", ".prd_popup_btn", function () {
  var inner_data = $(this).find(".block_how_much_storage_inner").html();
  $(".product_popup_data").append(inner_data);
  $(".itg_product_template_popup").addClass("active");
  $("html,body").addClass("blog_popup_active");
});

$(document).on("click", ".prd_popup_btn_sam-jane", function () {
  var inner_data_de = $(this).find(".block_how_much_storage_inner_de").html();
  var inner_data_en = $(this).find(".block_how_much_storage_inner_en").html();
  if (window.location.href.includes('https://de.elitescreens.eu/')) {
    $(".product_popup_data").append(inner_data_de);
  } else {
    $(".product_popup_data").append(inner_data_en);
  }
  
  $(".itg_product_template_popup").addClass("active");
  $("html, body").addClass("blog_popup_active");
});

$(document).on("click", ".product_popup_data .popup_close_btn", function () {
  $(".product_popup_data").empty();
  $(".itg_product_template_popup").removeClass("active");
  $("html,body").removeClass("blog_popup_active");
});

$(document).on("click", ".choose_model_section", function () {
  var inner_data = $(this).find(".choose_model_content_main").html();
  // console.log(inner_data);
  $(".product_popup_data").append(inner_data);
  $(".itg_product_template_popup").addClass("active screen_model_btn");
  $("body").addClass("blog_popup_active");
});
$(document).on("click", ".product_popup_data .popup_close_btn", function () {
  $(".product_popup_data").empty();
  $(".itg_product_template_popup").removeClass("active screen_model_btn");
  $("body").removeClass("blog_popup_active");
});

$(document).on('click', '.screen__material--label', function() {
  const variantMetaData = $(this).find('.variant_meta_data').html();
  $('.choose_model_section .first.variant_meta_data_clone').html(variantMetaData);
});

$(document).on("click", ".itg_product_template_popup", function (event) {
  if (!$(event.target).closest('.product_popup_data').length) {
    $(".product_popup_data").empty();
    $(".itg_product_template_popup").removeClass("active screen_model_btn");
    $("body").removeClass("blog_popup_active");
  }
});


$(document).on("keydown", function (event) {
  if (event.key === "Escape") {
    closePopup();
  }
});

function closePopup() {
  $(".product_popup_data").empty();
  $(".itg_product_template_popup").removeClass("active screen_model_btn");
  $("body").removeClass("blog_popup_active");
}

document.addEventListener('DOMContentLoaded', function() {
    const knobs = document.querySelectorAll('.one-xray .knob');
    if (knobs.length < 2) {
        return;
    }

    const xraySlider1knob = knobs[0];
    const xraySlider2knob = knobs[1];
    const knobOffset = window.innerHeight / 5;

    function checkInView(element, { offset = 0 } = {}) {
        const rect = element.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        return rect.top <= windowHeight - offset && rect.bottom >= offset;
    }

    function throttle(delay, callback) {
        let lastCall = 0;
        return function (...args) {
            const now = new Date().getTime();
            if (now - lastCall >= delay) {
                lastCall = now;
                callback(...args);
            }
        };
    }

    function handlePageScroll() {
        function triggerSliderAnimationIfInView(knobNode) {
            if (knobNode && checkInView(knobNode, { offset: knobOffset })) {
                const container = knobNode.closest('.one-xray');
                if (container && !container.classList.contains('slider-center')) {
                    container.classList.add('slider-center');
                }
            }
        }
        triggerSliderAnimationIfInView(xraySlider1knob);
        triggerSliderAnimationIfInView(xraySlider2knob);
    }

    const throttledHandlePageScroll = throttle(200, handlePageScroll);
    document.addEventListener('scroll', throttledHandlePageScroll, false);
});

document.addEventListener("DOMContentLoaded", function () {
    let popup;
    let delay;
    const url = window.location.href;

    if (url.includes('https://de.elitescreens.eu/')) {
        popup = document.querySelector(".page__popup--content-de");
    } else if (url.includes('https://fr.elitescreens.eu/')) {
        popup = document.querySelector(".page__popup--content-fr");
    } else if (url.includes('https://es.elitescreens.eu/')) {
        popup = document.querySelector(".page__popup--content-es");
    } else if (url.includes('https://it.elitescreens.eu/')) {
        popup = document.querySelector(".page__popup--content-it");
    } else if (url.includes('https://nl.elitescreens.eu/')) {
        popup = document.querySelector(".page__popup--content-nl");
    } else {
        popup = document.querySelector(".page__popup--content-en");
    }

    if (popup) {
        delay = Number(popup.getAttribute("data-delay")) || 3000; // Default delay if missing
        console.log("delay: ", delay);
        if (!sessionStorage.getItem("popupClosed")) {
            setTimeout(() => {
                popup.classList.add("active");
            }, delay);
        }

        const closeBtn = popup.querySelector(".page__popup--btn");
        if (closeBtn) {
            closeBtn.addEventListener("click", function () {
                popup.classList.remove("active");
                sessionStorage.setItem("popupClosed", "true");
            });
        }
    }
});










